if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', class FreeShippingBar extends HTMLElement {
    constructor() {
      super();
      
      this.currentProgress = this.dataset.currentProgress;
      this.threshold = this.dataset.threshold;
      this.currentTotal = this.dataset.currentTotal;
      this.achievedText = this.dataset.achievedText;
      this.notAchievedText = this.dataset.notAchievedText;
      this.updateProgress();

      this.unsubscribe = subscribe("UPDATE_PROGRESS_BAR", (event) => {
        this.updateProgress(event.currentTotal);
      });
    }

    disconnectedCallback() {
      if (this.unsubscribe && typeof this.unsubscribe === 'function') {
        this.unsubscribe();
      }
    }

    connectedCallback() {
        this.textElement = this.querySelector('[data-text]');
        const currentProgress = this.dataset.currentProgress;

        if (!isNaN(currentProgress)) {
            this.currentProgress = Number(currentProgress);
        } else {
            this.currentProgress = 0;
        }

        const currentTotal = this.dataset.currentTotal;

        if (!isNaN(currentTotal)) {
            this.currentTotal = Number(currentTotal);
        } else {
            this.currentTotal = 0;
        }

        const achievedText = this.dataset.achievedText;

        if (achievedText) {
            this.achievedText = achievedText;
        }

        const notAchievedText = this.dataset.notAchievedText;

        if (notAchievedText) {
            this.notAchievedText = notAchievedText;
        }

        const threshold = this.dataset.threshold;

        if (threshold && !isNaN(threshold)) {
            this.threshold = Number(threshold);
        } else {
            this.threshold = 0;
        }
    }

    updateProgress(currentTotal) {
        if (!currentTotal || isNaN(currentTotal)) {
          return;
        }

        this.currentTotal = Number(currentTotal);
        this.currentProgress = (this.currentTotal / this.threshold) * 100;

        if (this.currentProgress >= 100) {
          this.currentProgress = 100;
        }

        this.style.setProperty('--free-shipping-bar-width', `${this.currentProgress}%`);
        this.updateText();
    }

    updateText() {
      if (this.textElement) {
        if (this.currentProgress >= 100) {
          this.textElement.innerHTML = this.achievedText;
        } else if (this.currentTotal < this.threshold) {
          this.textElement.innerHTML = this.notAchievedText.replace(
            '::amount::',
            (this.threshold - this.currentTotal).toLocaleString(window.Shopify.locale, { style: 'currency', currency: window.Shopify.currency.active })
          );
        }
      }
    }
  });
}